import Owner from '~models/owner'
import Pet from '~models/pet'
import Vet from '~models/vet'

import Message from './message'
import { State, VetFinder } from './types'

export { default as Message } from './message'
export * from './types'

namespace Consultation {
  export interface ConcernLevel {
    concern_lv: number | null
    concern_lv_expression: string | null
    concern_lv_description: string | null
    issue_review: string | null
  }

  export interface ILevel1 {
    id: number
    main_concern: string
    details: string
    pet: Pet.Level1
    state: State
    created_at: string
    sharable_title: string
    generated_title: string | null
    owner: {
      id: Owner.Level1['id']
      thumbnail_uri: Owner.Level1['thumbnail_uri']
      nickname: Owner.Level1['nickname']
    }
    thumbnail_url: string | null
    match_rate: number | null
    answer_preview: string | null
    issue_keywords: string[]
  }

  export class Level1 implements ILevel1 {
    id: number = 0
    main_concern: string = ''
    details: string = ''
    pet: Pet.Level1
    state: State = State.Pending
    created_at: string
    sharable_title: string // url에 사용되는 title
    generated_title: string | null // gpt가 생성한 title
    owner: {
      id: Owner.Level1['id']
      thumbnail_uri: Owner.Level1['thumbnail_uri']
      nickname: Owner.Level1['nickname']
    }
    thumbnail_url: string | null
    match_rate: number | null
    answer_preview: string | null
    issue_keywords: string[]

    constructor(props: Readonly<ILevel1>) {
      this.id = props.id
      this.main_concern = props.main_concern
      this.details = props.details
      this.pet = props.pet
      this.state = props.state
      this.created_at = props.created_at
      this.sharable_title = props.sharable_title
      this.generated_title = props.generated_title
      this.owner = props.owner
      this.thumbnail_url = props.thumbnail_url
      this.match_rate = props.match_rate
      this.answer_preview = props.answer_preview
      this.issue_keywords = props.issue_keywords

      return { ...this }
    }
  }

  export type CheckupSummary = {
    [title: string]: string[]
  }

  export interface ILevel2 extends ILevel1, ConcernLevel {
    pet_id: number
    conversation: Message.Response[]
    vet: Vet.Level1 | null
    checkup_data: Record<string, string>
    checkup_summary: CheckupSummary | null
    owner: Pick<Owner.Level1, 'id' | 'thumbnail_uri' | 'nickname'>
    concern_lv: number | null
    concern_lv_expression: string | null
    concern_lv_description: string | null
    issue_review: string | null
    vet_finder?: VetFinder | null
  }

  export class Level2 extends Level1 implements ILevel2 {
    pet_id: number = 0
    conversation: Message.Response[] = []
    vet: Vet.Level1 | null = null
    checkup_data: Record<string, string>
    checkup_summary: CheckupSummary | null
    owner: Pick<Owner.Level1, 'id' | 'thumbnail_uri' | 'nickname'>
    concern_lv: number | null
    concern_lv_expression: string | null
    concern_lv_description: string | null
    issue_review: string | null
    vet_finder: VetFinder | null

    constructor(props: Readonly<ILevel2>) {
      super(props)

      this.pet_id = props.pet_id
      this.conversation = props.conversation
      this.vet = props.vet
      this.checkup_data = props.checkup_data
      this.checkup_summary = props.checkup_summary
      this.owner = props.owner
      this.concern_lv = props.concern_lv
      this.concern_lv_expression = props.concern_lv_expression
      this.concern_lv_description = props.concern_lv_description
      this.issue_review = props.issue_review
      this.vet_finder = props.vet_finder ?? null

      return { ...this }
    }
  }
}

export default Consultation
